var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example elevation-1"},[_c('p',{staticClass:"source"},[_vm._v(_vm._s(_vm.value.text))]),_c('p',{staticClass:"target"},[_vm._v(_vm._s(_vm.value.translatedText))])])}
var staticRenderFns = []

export { render, staticRenderFns }